<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('Confirm the order')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="body" v-if="store_final_total_list">
      <div class="block-wrapper">

        <checkout-address class="address" v-on:onclick="goAddress"
          :item="store_final_total_list.address_info"></checkout-address>

        <div v-if="store_final_total_list.if_presell" @click="togglePresell = true">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe664;</span>
              <span>支付金额</span>
            </div>
            <span slot="right">{{ presell_pay == '1' ? '全额支付' : '先付定金' }}</span>
          </flex-line>
        </div>
        <!--付款方式-->
        <div v-if="store_final_total_list.address_api.allow_offpay == 1 && store_final_total_list.ifshow_offpay"
          @click="togglePay = true">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe664;</span>
              <span>付款方式</span>
            </div>
            <span slot="right">{{ pay_name }}</span>
          </flex-line>
        </div>
        <!--发票-->
        <!-- <div
          @click="$router.push({ name: 'MemberInvoiceList', query: { isFromCheckout: true, goBackLevel: -1, invoice_id: invoice_id, vat_deny: store_final_total_list.vat_deny, params: JSON.stringify($route.query) } })">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe664;</span>
              <span>发票</span>
            </div>
            <span slot="right">{{ invoice_content }}</span>
          </flex-line>
        </div> -->
        <!--平台代金券-->
        <div v-if="myMallVoucher != ''" @click="toggleMallVoucher(1)">
          <flex-line class="menu-item" :is-link="true" :show-border="true">
            <div>
              <span class="left-icon iconfont">&#xe664;</span>
              <span>平台代金券</span>
            </div>
            <span slot="right">{{ myMallVoucherprice }}</span>
          </flex-line>
        </div>
      </div>
      <checkout-store class="section-header" :addressInfo="store_final_total_list.address_info"
        :payGoodsList="store_final_total_list.pay_goods_list"
        :finalTotalList="store_final_total_list.store_final_total_list" :addressApi="store_final_total_list.address_api"
        :storeCartList="store_final_total_list.store_cart_list" :ifshowOffpay="store_final_total_list.ifshow_offpay"
        @selectMallVoucher="selectMallVoucher" @selectVoucher="selectVoucher" @selectChain="selectChain"
        @changeMessage="changeMessage"></checkout-store>
    </div>
    <div class="bottom-wrapper" v-if="store_final_total_list && store_final_total_list.limit == false">
      <flex-line v-if="!f_code_check && store_final_total_list.store_cart_list_api[0].goods_list[0].is_goodsfcode == 1"
        class="field-line"><span class="field-name">F码</span>
        <div class="field-line-right" slot="right"><input class="field-input" v-model="f_code" placeholder="请填写F码" />
          <div class="common-btn ds-button-small" @click="checkfcode">使用</div>
        </div>
      </flex-line>
      <div v-else class="amount-wrapper">
        <div class="common-btn ds-button-large" @click="checkout">{{ $t('Submit an order') }}</div>
      </div>
    </div>
    <div class="bottom-wrapper" v-else>
      <!-- <div class="amount-wrapper">
        <div class="common-btn ds-button-large">该地区不可购买，请更换收货地区</div>
      </div> -->
    </div>
    <mt-popup v-model="togglePay" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="付款方式" class="common-header">
          <mt-button slot="left" icon="back" @click="togglePay = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <mt-radio v-model="pay_code" :options="pay_options">
        </mt-radio>
      </div>
    </mt-popup>
    <mt-popup v-model="togglePresell" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="支付金额" class="common-header">
          <mt-button slot="left" icon="back" @click="togglePresell = false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <mt-radio v-model="presell_pay" :options="presell_options">
        </mt-radio>
        <div class="desc-text">定金下单后，若非商城或商家责任，定金恕不退还</div>
      </div>
    </mt-popup>
    <mt-popup v-model="mallvoucherVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="平台代金券" class="common-header">
          <mt-button slot="left" icon="back" @click="toggleMallVoucher(0)"></mt-button>
          <div class="common-btn btn" slot="right" @click="selectMallVoucher('')">不使用</div>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <div class="common-voucher common-voucher02" v-for="(item, index) in myMallVoucher" :key="item.mallvoucheruser_id"
          @click="selectMallVoucher(item)">
          <div class="par">
            <p>订单满{{ item.mallvoucheruser_limit }}元</p><sub class="sign">$</sub><span>{{ item.mallvoucheruser_price
            }}</span>
          </div>
          <div class="copy">有效期至<p><br>{{ $moment.unix(item.mallvoucheruser_enddate).format('YYYY.MM.DD') }}</p>
          </div>
          <i></i>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import { buyStep1, buyStep2, checkFCode, getChainList } from '../../../api/memberBuy'
import CheckoutAddress from './child/CheckoutAddress'
import CheckoutStore from './child/CheckoutStore'

import flexLine from '../../flexLine'
export default {
  name: 'Step1',
  components: {
    flexLine,
    CheckoutAddress,
    CheckoutStore
  },
  data() {
    return {
      togglePresell: false,
      presell_pay: '1',
      pay_name: '在线付款',
      pay_code: 'online',
      pay_options: [{
        label: '在线付款',
        value: 'online'
      }, {
        label: '货到付款',
        value: 'offline'
      }],
      presell_options: [{
        label: '全额支付',
        value: '1'
      }, {
        label: '先付定金',
        value: '2'
      }],
      pay_list: { online: '在线付款', offline: '货到付款' },
      togglePay: false,
      hidePay: false,
      f_code: '',
      invoice_id: this.$route.query.invoice_id ? this.$route.query.invoice_id : 0,
      invoice_content: this.$route.query.invoice_content ? this.$route.query.invoice_content : '',
      f_code_check: false,
      cart_id: this.$route.query.cart_id ? this.$route.query.cart_id : '',
      store_final_total_list: null,
      message: [],
      chain_goods: [],
      myMallVoucher: [],
      myMallVoucherprice: '不使用',
      mallvoucherVisible: false,
      mall_voucher_info: '',
    }
  },
  watch: {
    pay_code: function (pay_code) {
      this.pay_name = this.pay_list[pay_code]
      this.togglePay = false
      if (pay_code == 'offline' && !this.store_final_total_list.pay_goods_list.online) {
        this.hidePay = true
      } else {
        this.hidePay = false
      }
    }
  },
  created: function () {
    this.getBuyInfo()
  },
  methods: {
    checkfcode() {
      checkFCode(this.store_final_total_list.store_cart_list_api[0].goods_list[0].goods_commonid, this.f_code).then(res => {
        this.f_code_check = true
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 获取订单信息
    getBuyInfo() {
      let extra = {}
      if (this.$route.query.bargainorder_id) {
        extra['bargainorder_id'] = this.$route.query.bargainorder_id
      }
      buyStep1(
        this.cart_id, this.$route.query.buy_now ? 0 : 1, this.$route.query.pintuan_id, this.$route.query.pintuangroup_id, extra
      ).then((res) => {
        if (res.code === 10000) {
          this.store_final_total_list = res.result
          this.myMallVoucher = res.result.mall_voucher_list
          if (this.invoice_content) {
            if (!this.store_final_total_list.inv_info.invoice_id) {
              this.invoice_id = 0
              this.invoice_content = this.store_final_total_list.inv_info.invoice_title
            }
          } else {
            this.invoice_content = this.store_final_total_list.inv_info.invoice_title
            if (this.store_final_total_list.inv_info.invoice_id) {
              this.invoice_id = this.store_final_total_list.inv_info.invoice_id
            }
          }
        } else {

        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    selectVoucher(voucherInfo, store_id) {
      this.store_final_total_list.store_cart_list[store_id].store_voucher_info = voucherInfo
    },
    selectMallVoucher(voucherInfo) {
      this.toggleMallVoucher(0)
      this.mall_voucher_info = voucherInfo
      if (this.mall_voucher_info) {
        this.myMallVoucherprice = this.mall_voucher_info.mallvoucheruser_price + '元'
      } else {
        this.myMallVoucherprice = '不使用'
      }
    },
    selectChain(chain, store_id) {
      this.store_final_total_list.store_cart_list[store_id].chain_goods = chain[store_id]
    },
    toggleMallVoucher(Visible) {
      if (Visible === 1) {
        this.mallvoucherVisible = true
      } else {
        this.mallvoucherVisible = false
      }
    },
    goAddress() {
      if (this.store_final_total_list.address_info) {
        this.$router.push({ name: 'MemberAddressList' })
      } else {
        this.$router.push({
          name: 'MemberAddressForm',
          query: {
            action: 'add',
            isFromCheckout: true,
            goBackLevel: -1
          }
        })
      }
    },
    changeMessage(message, store_id) {
      this.message[store_id] = message
    },
    // 提交订单
    checkout() {
      let ifcart = this.$route.query.buy_now ? 0 : 1
      let pintuan_id = this.$route.query.pintuan_id
      let pintuangroup_id = this.$route.query.pintuangroup_id
      let cart_id = this.cart_id
      let address_id = this.store_final_total_list.address_info ? this.store_final_total_list.address_info.address_id : 0
      let vat_hash = this.store_final_total_list.vat_hash
      let offpay_hash = this.store_final_total_list.address_api.offpay_hash
      let offpay_hash_batch = this.store_final_total_list.address_api.offpay_hash_batch
      let invoice_id = this.invoice_id
      let voucher = null
      let mallvoucher = null
      let chaininfo = null
      let pay_message_temp = []
      let f_code = this.f_code
      let pay_code = this.pay_code
      if (!address_id) {
        // MessageBox.alert(this.$t('Please add address'), '')
        Toast(this.$t('Please add address'))
        return
      }

      // 处理格式
      voucher = ''
      let voucher_temp = []
      for (var t in this.store_final_total_list.store_cart_list) {
        voucher_temp.push([this.store_final_total_list.store_cart_list[t].store_voucher_info.vouchertemplate_id + '|' + t + '|' + this.store_final_total_list.store_cart_list[t].store_voucher_info.voucher_price])
      }
      voucher = voucher_temp.join(',')

      mallvoucher = '|0.00'
      if (this.mall_voucher_info != '') {
        mallvoucher = this.mall_voucher_info.mallvouchertemplate_id + '|' + this.mall_voucher_info.mallvoucheruser_price
      }

      chaininfo = ''
      let chain_temp = []
      for (var t in this.store_final_total_list.store_cart_list) {
        if (this.store_final_total_list.store_cart_list[t].chain_goods) {
          chain_temp.push([t + '|' + this.store_final_total_list.store_cart_list[t].chain_goods.chain_id])
        }
      }
      chaininfo = chain_temp.join(',')

      let i
      for (i in this.store_final_total_list.store_cart_list) {
        let message = this.message[this.store_final_total_list.store_cart_list[i].store_id]
        if (typeof (message) === 'undefined') {
          message = ''
        }
        pay_message_temp.push(this.store_final_total_list.store_cart_list[i].store_id + '|' + message)
      }
      let pay_message = pay_message_temp.join(',')
      let extra = {}
      if (this.$route.query.bargainorder_id) {
        extra['bargainorder_id'] = this.$route.query.bargainorder_id
      }
      extra['chain_goods'] = chaininfo
      extra['presell_pay'] = this.presell_pay
      buyStep2(
        ifcart,
        cart_id,
        address_id,
        vat_hash,
        offpay_hash,
        offpay_hash_batch,
        invoice_id,
        voucher,
        mallvoucher,
        pay_message,
        pintuan_id,
        pintuangroup_id,
        f_code,
        pay_code,
        extra
      ).then((res) => {
        // 跳转到支付界面
        let pay_sn = res.result.pay_sn
        this.$router.push({ name: 'MemberBuyPay', query: { pay_sn: pay_sn, pay_type: 'pay_new' } })
      }).catch(error => {
        this.password = ''
        Toast(error.message)
      })
    }

  }
}
</script>

<style scoped lang="scss">
.common-header {
  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.block-wrapper {
  background: #fff;
  padding: 0 $pageSpace
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.header {
  height: 2.2rem;
  color: #48505d;
  font-size: $h1;
  background-color: #fff;
  padding: 0.1rem 0;
  border-bottom: 1px solid #e8eaed;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-bottom: 4rem;
}

.goods {
  height: 4.5rem;
}

.item {
  height: 2.5rem;
}

.section-header {
  margin-top: 0.4rem;
}

.section-footer {
  margin-bottom: 0.4rem;
}

.comment {
  height: 7.25rem;
}

.desc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.desc-item {
  height: 1.5rem;
}

.bottom-wrapper {
  z-index: 1;
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: .5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
}

.amount-wrapper {
  flex: 1;
  background-color: #fff;
  margin: 0 $pageSpace;
}

.amount {
  flex: 1;
  font-size: $h2;
  color: $primaryColor;
  text-align: right;
  padding-right: 0.75rem;
}

.submit {
  width: 7.5rem;
  height: 2.5rem;
  border-radius: 0;
}

.common-voucher {
  margin: 0.5rem auto
}

.left-icon {
  float: left;
  font-size: $h1;
  margin-right: 0.2rem;
}

.desc-text {
  font-size: $subFontSize;
  color: #999;
  padding: 1rem
}
</style>
